import React, { useContext, useState } from 'react';
import './BurgerMenu.scss';
import { NavLink } from 'react-router-dom';
import { Context } from '../../../index';

interface BurgerMenuProps {
  logOut: () => void;
}

const BurgerMenu = (props: BurgerMenuProps): JSX.Element => {
  const { store } = useContext(Context);
  const [active, setActive] = useState(false);
  return (
    <>
      <div
        className={`HeaderBox-BurgerIcon ${active ? 'active' : ''}`}
        onClick={() => {
          setTimeout(() => {
            setActive(!active);
          }, 200);
        }}
      ></div>
      <div className="burgerContainer">
        <nav className={`header__menu ${active ? 'active' : ''}`}>
          <div className="header__border"></div>
          <ul className="header__list">
            <li>
              <NavLink
                to="/"
                onClick={() => {
                  setTimeout(() => {
                    setActive(!active);
                  }, 200);
                }}
              >
                Главная
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/map"
                onClick={() => {
                  setTimeout(() => {
                    setActive(!active);
                  }, 200);
                }}
              >
                Карта
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/about"
                onClick={() => {
                  setTimeout(() => {
                    setActive(!active);
                  }, 200);
                }}
              >
                О проекте
              </NavLink>
            </li>
            <li>
              <NavLink
                to="/personal-area"
                onClick={() => {
                  setActive(!active);
                }}
              >
                Личный кабинет
              </NavLink>
            </li>
            {store.isAuth && (
              <div
                onClick={() => {
                  props.logOut();
                  setActive(!active);
                }}
              >
                Выход
              </div>
            )}
          </ul>
          <NavLink
            to="/personal-area"
            onClick={() => {
              store.setCurrentTab('2');
              setTimeout(() => {
                setActive(!active);
              }, 200);
            }}
          >
            <button>Сообщить о проблеме</button>
          </NavLink>
        </nav>
      </div>
    </>
  );
};

export default BurgerMenu;
